import React from 'react'
import "./footer.css"

export const Footer = () => {
    return (
        <footer className='footer'>
            <a href='https://lucaspoma.netlify.app/' target="_blank" className='link'>Diseñado y desarrollado por Lucas Poma</a>
        </footer>
    )
}

export default Footer